module.exports = __webpack_public_path__ + "static/media/alert.39640042.png";